import HomeHelpInfo from 'src/components/HelpInfo/HomeHelpInfo';
import BusinessHelpInfo from 'src/components/HelpInfo/BusinessHelpInfo';
import AssetsHelpInfo from 'src/components/HelpInfo/AssetsHelpInfo';
import LeasedAssetsHelpInfo from 'src/components/HelpInfo/LeasedAssetsHelpInfo';
import ReviewHelpInfo from 'src/components/HelpInfo/ReviewHelpInfo';

export default [
  HomeHelpInfo,
  BusinessHelpInfo,
  AssetsHelpInfo,
  LeasedAssetsHelpInfo,
  ReviewHelpInfo,
];
